import React, {useState} from 'react';
import MusicPlayer from './MusicPlayer';
import VisibilitySensor from 'react-visibility-sensor';
import { motion } from 'framer-motion';

const Search = () => {

    const [elementIsVisible, setElementIsVisible] = useState(false);

    const redimg = {
        true: {
            left: "18rem",
        },
        false: {
            left: "16rem",
        },
    };

    const musicimg = {
        true: {
            left: "2rem",
        },
        false: {
            left: "6rem",
        },
    };

  return (
    <div 
        className="search relative h-[65rem] px-[5rem] bg-[#081730] pt-[18rem] pb-[10rem] mt-[-15rem] z-[1] flex items-center justify-between rounded-b-[5rem]"
    >
        {/* Left side */}
        <div 
            className="left flex-1" 
        >
            <img
                src={require('../img/backgraphics.png')}
                alt=''
                className='absolute top-[22rem] left-[-55rem]'
            />
            <img 
                src={require('../img/d1.png')}
                alt=''
                className='w-[16rem] top-[26rem] absolute'
            />
            <img 
                src={require('../img/d2.png')}
                alt=''
                className='w-[9rem] top-[32.7rem] absolute left-[7rem]'
            />
            <motion.img 
                variants={redimg}
                animate={`${elementIsVisible}`}
                transition={{
                  duration: 1.2,
                  type: "ease-out",
                }}
                src={require('../img/d3.png')}
                alt=''
                className='w-[9rem] top-[33rem] left-[17rem] absolute'
            />
            <motion.img 
                variants={musicimg}
                animate={`${elementIsVisible}`}
                transition={{
                  duration: 1,
                  type: "ease-out",
                }}
                src={require('../img/d4.png')}
                alt=''
                className='w-[17rem] top-[50rem] left-[2rem] absolute'
            />
        </div>
        {/* Right side */}
        <div 
            className="right flex items-start flex-col justify-start flex-1 h-[100%] pt-[9rem]"
        >
            
            {/* Searchbar */}
            <div 
                className="searchbar flex justify-start w-[100%]"
            >
                <input 
                    type='text'
                    placeholder='Enter the keyword or URL'
                    className='flex-[19] outline-none bg-[#020917] rounded-xl p-3 h-[3rem]'
                />
                {/* SearchIcon */}
                <div 
                    className="search-icon flex flex-1 items-center rounded-xl ml-4 bg-gradient-to-bl from-[#F3071D] to-[#E600ff] p-4 h-[3rem]"
                >
                    <img 
                        src={require('../img/search.png')}
                        alt=''
                        className='w-[1.5rem]'
                    />
                </div>
            </div>
            {/* Tild icon */}
            <div 
                className='tild flex justify-start mt-7 items-center w-[100%]'
            >
                <img 
                    src={require('../img/Path 318.png')}
                    alt=''
                    className='w-[5rem]'
                />
            </div>
            {/* Paragraph */}
            <div
                className='detail flex flex-col mt-5 text-4xl'
            >
                <span>
                    Search Music By
                </span>
                <span>
                    <b>Name or Direct URL</b>
                </span>
                <span
                    className='text-sm mt-3 text-[#4D586A]'
                >
                    Duis feugiat congue metus, ultrices vulputate <br /> nibh viverra eget. Vestibulum ullamcorper <br /> volutpat varius.
                </span>
            </div>
            {/* Music player */}
            <VisibilitySensor
                onChange={(isVisible) => setElementIsVisible(isVisible)}
            >
                <MusicPlayer /> 
            </VisibilitySensor>
        </div>
    </div>
  )
}

export default Search